import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { IOptionsResponse } from '../../../common/common.types'
import { OptionsService } from '../services/options.service'
import { setTransportFactorsOptions } from '../store/options.actions'

export function* getTransportFactorsOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getTransportFactorsOptions])
    const { entity } = response
    if (entity) entity.push({ id: 20, name: 'Other', isPN: false, isNV: false, nemsisCode: 2211013 })
    yield put(setTransportFactorsOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getTransportFactorsOptions() error: ${e}`))
  }
}

export function* getTransportFactorsOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getTransportFactorsOptions)
}
